export default __webpack_public_path__ + "static/1226-f26f96d3b2b29030c561f7644b9c3976.gif";